import axios from 'axios'

const jWeixin = window.wx

const wxInit = async function () {
  try {
    const url = window.location.href.split('#')[0]
    // const url = localStorage.getItem('url')
    // const url = localStorage.getItem('url')
    // if (!url || url === 'https://shiyu.live/pLogin') {
    //   return false
    // }

    const res = await axios.get('/py_api/wxpay/signature', {
      params: { url }
    })

    const data = res.data.result

    return new Promise((resolve) => {
      jWeixin.config({
        debug: process.env.NODE_ENV !== 'production',
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['getLocation', 'chooseImage', 'previewImage', 'uploadImage', 'requestMerchantTransfer']
      })
      jWeixin.ready(() => {
        console.log('微信JS-SDK初始化成功')
        resolve(true)
      })

      jWeixin.error((err) => {
        console.error('微信JS-SDK初始化失败', err)
        resolve(false)
      })
    })
  } catch (err) {
    console.error('获取微信签名失败', err)
    return false
  }
}

const getLocation = async function () {
  try {
    return new Promise((resolve, reject) => {
      jWeixin.getLocation({
        type: 'gcj02',
        success: (res) => {
          resolve({
            latitude: res.latitude,
            longitude: res.longitude
          })
        },
        fail: (err) => {
          reject(err)
        }
      })
    })
  } catch (error) {
    throw error
  }
}

const checkJsApi = async function () {
  try {
    return new Promise((resolve, reject) => {
      jWeixin.checkJsApi({
        success: (res) => {
          resolve(res)
        },
        fail: (err) => {
          reject(err)
        }
      })
    })
  } catch (error) {
    throw error
  }
}

export { jWeixin, wxInit, getLocation, checkJsApi }



// WEBPACK FOOTER //
// ./src/filters/wxInit.js